/**
 * Persisted state to saving last active route data.
 * Only authorized routes will be saved.
 */
import shortid from 'shortid';

export default apiHandler => ({
    namespaced: true,
    state: {
        // the key of vue-router element
        // please update that value to force re-render application
        appRenderKey: shortid.generate(),
        path: undefined,
        history: [],
    },
    getters: {
        path: state => state.path,
        history: state => state.history,
    },
    mutations: {
        reRender(state) {
            state.appRenderKey = shortid.generate();
        },
        setPath(state, path) {
            state.path = path;
        },
        updateHistory(state, history) {
            if (history.root) {
                state.history = [];
                state.history.push(history);
                return;
            }
            const historyInState = state.history.find(
                item => item.fullPath === history.fullPath,
            );
            if (historyInState) {
                // Use `index + 1` to force slice end to be inclusive.
                const end = state.history.indexOf(historyInState) + 1;
                state.history = state.history.slice(0, end);
            } else if (!state.history.length) {
                const {label = 'Dashboard', name = 'dashboard'} = history.meta.root || {};
                history = {
                    ...history,
                    fullPath: `/${name}`,
                    label,
                    route: {name},
                };
                state.history = [history];
            } else {
                state.history.push(history);
            }
            // The `slice(-4)` will cut the array so that only the last 3 histories are available
            // any before then are lost to time.
            state.history = state.history.splice(-4);
        },
        clearHistory(state) {
            state.history = [];
        },
    },
    actions: {
        setPath({commit}, path) {
            // Cancel all unfinished requests on changing page.
            apiHandler.cancelAllRequests();
            commit('setPath', path);
        },
        updateHistory({commit}, history) {
            commit('updateHistory', history);
        },
        clear({commit}) {
            // Clear router state on logout.
            commit('setPath', undefined);
            commit('clearHistory');
        },
        reRender({commit}) {
            commit('reRender');
        },
    },
});
